import { getLoggedInUser } from "./helpers";

export const checkLoginExpirationTime = () => {
  const user = getLoggedInUser();
  if (user && user.loginTime) {
    const now = Date.now();
    const hours = 12 * 60 * 60 * 1000;

    if (now - parseInt(user.loginTime) > hours) {
      localStorage.clear();
      window.location.href = "/login";
    }
  } else {
    localStorage.clear();
    window.location.href = "/login";
  }
};
